/**
 * 课程管理 相关菜单配置
 *
 */

// import Layout from "../components/layout";
import { lazyLoad } from "@/utils/lazyLoad";
const courseRoute = [
  {
    // component: Layout,
    component: lazyLoad,
    path: "course-manage",
    meta: {
      title: "课程管理",
      icon: "icon-course",
    },
    children: [
      {
        path: "/course/list",
        name: "CourseList",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/pages/courseManage/courseList"
          ),
        meta: {
          title: "课程列表",
          icon: "home",
          keepAlive: true,
        },
      },
      {
        path: "/course/create",
        name: "CourseCreate",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/pages/courseManage/courseCreate"
          ),
        meta: {
          title: "创建课程",
          icon: "home",
        },
      },
    ],
  },
];
export default courseRoute;
